import React, { ChangeEvent, useEffect, useRef, useState } from "react";
import CommonTable, { TableColumn } from "../../components/Table/CommonTable";
import {
  postDetails,
  postMultipartDetails,
} from "../../services/http/http.service";
import APIList from "../../utils/constants/APIList";
import { Trash3Fill, PlusCircleFill } from "react-bootstrap-icons";
import { Button, Modal, ModalBody } from "react-bootstrap";
import CroppingModal from "../../components/Cropping Modal/CroppingModal";
import CustomButton from "../../components/CustomButton/CustomButton";
import CustomDatePicker from "../../components/CustomDatePicker/CustomDatePicker";
import InputField from "../../components/InputField/InputField";
import PageHeader from "../../components/PageHeader/PageHeader";
import encrypt from "../../utils/helpers/encrypt";
import { validateImageFile } from "../../utils/helpers/validateFileUpload";
import { showLoader, hideLoader } from "../../store/Loader/loader.slice";
import { useAppDispatch } from "../../store/storeRequests";
import { showToast, hideToast } from "../../store/Toast/toast.slice";
import profileIcon from "../../assets/default-profile.png";
import "./zigsawchallenge.scss";
import { SlArrowLeft, SlArrowRight } from "react-icons/sl";

export interface Zigsaw {
  id: number;
  folder_name: string;
  title: string;
  description: string;
  folder_image: string;
  status: number;
  report: any;
  // closeDate: string | number | Date;
}

export interface ZigsawChallengePayload {
  title: string;
  folder_name: string;
  description: string;
  closeDate?: string;
  id?: number;
}

interface ViewResponse {
  id: number;
  solved_time: number;
  name: string;
  profile: string;
}

const useSearchAndPaginate = (data:any, query:string, pageSize:number, pageNumber:number) => {
  
  const filteredData = data.filter(
    (item:any) =>{
     return item.name.toLowerCase().includes(query.toLowerCase())
  });


  // 2. Paginate the filtered data
  const totalPages = Math.ceil(filteredData.length / pageSize);
  const start = (pageNumber - 1) * pageSize;
  const paginatedData = filteredData.slice(start, start + pageSize);

  return { paginatedData, totalPages };
};


const VideoChallengeData = () => {
  const [showModal, setShowModal] = useState(false);
  const [showCroppingModal, setShowCroppingModal] = useState(false);
  const [folder_name, setFolder_name] = useState("");
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [folderImage, setFolderImage] = useState<{ value: any; src: string }>({
    value: null,
    src: "",
  });
  // const [closeDate, setCloseDate] = useState<Date | null>(null);
  const [selectedItems, setSelectedItems] = useState<Set<number>>(new Set());
  const [data, setData] = useState<Zigsaw[]>([]);
  const [isEditing, setIsEditing] = useState(false);
  const [currentItemId, setCurrentItemId] = useState<number | null>(null);
  const [imageChanged, setImageChanged] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [viewResponse, setViewResponse] = useState<ViewResponse[]>([]);
  const [showResponseModal, setShowResponseModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  // const [searchQuery, setSearchQuery] = useState('');
  const cmpMounted = useRef(false);
  const [originalData, setOriginalData] =
    useState<ZigsawChallengePayload | null>(null);
  const dispatch = useAppDispatch();
  // const [contactsPerPage] = useState(10); 
  // const [currentPage, setCurrentPage] = useState(1);

  const [query, setQuery] = useState(""); // Search query
  const [pageNumber, setPageNumber] = useState(1); // Current page
  const pageSize = 10;


  useEffect(() => {
    if (cmpMounted.current) return;
    cmpMounted.current = true;
    fetchZigsawChallenges();
  }, []);

  useEffect(() => {
    // Reset to the first page when the search query changes
    setPageNumber(1);
  }, [query]);

  const { paginatedData, totalPages } = useSearchAndPaginate(
    viewResponse,
    query,
    pageSize,
    pageNumber
  );

  const fetchZigsawChallenges = async () => {
    try {
      dispatch(showLoader("Loading Data..."));
      const response = await postDetails(APIList.GET_ALL_ZIGSAW_CHALLENGE, {});

      const modifiedData = response.data.data.map((item:Zigsaw)=> ({
        ...item,
        description: item.description ? item.description : "N/A",
      }));

      // setData(response.data.data);
      setData(modifiedData);
      // console.log(response.data.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      dispatch(hideLoader());
    }
  };

  function handleShowModal() {
    setFolder_name("");
    setTitle("");
    setDescription("");
    setFolderImage({ value: null, src: "" });
    // setCloseDate(null);
    setIsEditing(false);
    setImageChanged(false);
    setCurrentItemId(null);
    setShowModal(true);
  }

  const handleCloseDeleteModal = () => setShowDeleteModal(false);
  const handleCloseModal = () => setShowModal(false);
  const handleCloseResponseModal = () =>{ 
    // setCurrentPage(1)
    // setSearchQuery("");
    setQuery("");
    setPageNumber(1);
    setShowResponseModal(false);
  }

  const handleFolderChange = (e: ChangeEvent<HTMLInputElement>) =>{
    const value = e.target.value;
    // if (/^[A-Za-z0-9\s&?()]*$/.test(value)) {
    setFolder_name(e.target.value);
    // }
}
  const handleTitleChange = (e: ChangeEvent<HTMLInputElement>) =>{
    const value = e.target.value;
    // if (/^[A-Za-z0-9\s]*$/.test(value)) {
    setTitle(e.target.value);
    // }
}
  const handleDescriptionChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => setDescription(e.target.value);

  const handleCoverImageChange = (e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];

    if (!file) return;

    const validation = validateImageFile(file);
    if (!validation.valid) {
      dispatch(showToast(validation.message));
      setTimeout(() => dispatch(hideToast()), 3000);
      return;
    }

    const maxSize = 11* 1024 * 1024;
    if (file.size > maxSize) {
      // setErrorMessage(
      //   "File size exceeds the 10MB limit. Please upload a smaller file."
      // );
      dispatch(showToast( "File size exceeds the 10MB limit. Please upload a smaller file."));
      setTimeout(() => dispatch(hideToast()), 3000);

      return;
    }

    setFolderImage({
      value: file,
      src: URL.createObjectURL(file),
    });
    setShowCroppingModal(true);
    setImageChanged(true);
  };

  const handleCrop = (croppedImage: string) => {
    setFolderImage((prev) => ({ ...prev, src: croppedImage }));
    setShowCroppingModal(false);
  };

  const removeImage = () => {
    setFolderImage({ value: null, src: "" });
    setImageChanged(true);
  };

  const submitDetails = async (ev: React.FormEvent<HTMLFormElement>) => {
    ev.preventDefault();

    if (!isEditing && !folderImage.value) {
      // setErrorMessage("Please upload an Image.");
      dispatch(showToast("Please upload an Image."));
      setTimeout(() => dispatch(hideToast()), 3000);
      return;
    }

    if (!folder_name || !title || !description) {
      setErrorMessage("Please fill in all fields.");
      return;
    }

    // const formattedCloseDate = closeDate?.toISOString();
    const trimmedFolderName = folder_name.trim();

    const formData = new FormData();

    if (imageChanged && folderImage.value) {
      formData.append("mediafiles", folderImage.value);
    }

    const payload: ZigsawChallengePayload = {
      title,
      folder_name: trimmedFolderName,
      description,
      // closeDate: formattedCloseDate,
    };

    if (isEditing && currentItemId !== null && originalData) {
      const noChanges =
        originalData.title === title &&
        originalData.folder_name === folder_name &&
        originalData.description === description &&
        // originalData.closeDate === formattedCloseDate &&
        !imageChanged;

      if (imageChanged && !folderImage.value) {
        // setErrorMessage("Please upload an Image.");
        dispatch(showToast("Please upload an Image."));
        setTimeout(() => dispatch(hideToast()), 3000);
        return;
      }

      if (noChanges) {
        dispatch(showToast("No Changes Done."));
        setTimeout(() => dispatch(hideToast()), 3000);
        // setShowModal(false);
        return;
      }

      payload.id = currentItemId;
    }

    formData.append("data", encrypt(payload));

    try {
      let response;

      if (isEditing && currentItemId !== null) {
        response = await postMultipartDetails(
          APIList.EDIT_ZIGSAW_CHALLENGE,
          formData
        );
        if (response.statusCode === 200) {
          dispatch(showToast("Updated Successfully."));
          // setShowModal(false);
          // setFolder_name("");
          // setTitle("");
          // setDescription("");
          // setFolderImage({ value: null, src: "" });
          // setCloseDate(null);
          fetchZigsawChallenges();
        } else {
          dispatch(showToast(`Failed to Add : ${response.message}`));
        }
      } else {
        response = await postMultipartDetails(
          APIList.ADD_ZIGSAW_CHALLENGE,
          formData
        );
        if (response.statusCode === 200) {
          dispatch(showToast("Added Successfully."));
          setShowModal(false);
          setFolder_name("");
          setTitle("");
          setDescription("");
          setFolderImage({ value: null, src: "" });
          // setCloseDate(null);
          fetchZigsawChallenges();
        } else {
          dispatch(showToast(`Failed to Add : ${response.message}`));
        }
      }

      // console.log("Response:", response);

      setFolder_name("");
      setTitle("");
      setDescription("");
      setFolderImage({ value: null, src: "" });
      // setCloseDate(null);
      setShowModal(false);
      setErrorMessage("");
      fetchZigsawChallenges();
    } catch (error) {
      console.error("Error submitting details:", error);
    } finally {
      setTimeout(() => dispatch(hideToast()), 3000);
    }
  };

  const editItem = (item: Zigsaw) => {
    setFolder_name(item.folder_name || "");
    setTitle(item.title || "");
    setDescription(item.description === "N/A" ? "" : item.description);
    setFolderImage({ value: null, src: item.folder_image });
    // setCloseDate(new Date(item.closeDate));
    setIsEditing(true);
    setCurrentItemId(item.id);
    setOriginalData({
      title: item.title || "",
      folder_name: item.folder_name || "",
      description: item.description || "",
      // closeDate: item.closeDate.toString(),
    });
    setShowModal(true);
    setErrorMessage("");
    setImageChanged(false);
  };

  const deleteItemById = async (item: Zigsaw) => {
    try {
      const response = await postDetails(
        APIList.DELETE_ZIGSAW_CHALLENGE_FOLDER,
        {
          id: item.id,
        }
      );

      if (response.status === "Failed") {
        console.log("Cannot delete folder");
        return;
      }

      setData((prevData) => prevData.filter((row) => row.id !== item.id));
      // console.log("Folder deleted");
      dispatch(showToast("Deleted Succesfully."));
      setTimeout(() => dispatch(hideToast()), 3000);
    } catch (error) {
      console.error("Error deleting folder:", error);
    }
  };

  const handleBulkDelete = async () => {
    try {
      for (const id of selectedItems) {
        const itemToDelete = data.find((item) => item.id === id);
        if (itemToDelete) {
          await deleteItemById(itemToDelete);
        }
      }
      setSelectedItems(new Set());
      setShowDeleteModal(false);
    } catch (error) {
      console.error("Error deleting items:", error);
    }
  };

  const toggleStatus = async (item: Zigsaw) => {
    try {
      const newStatus = item.status === 0 ? 1 : 0;
      const response = await postDetails(
        APIList.ZIGSAW_CHALLENGE_STATUS_UPDATE,
        {
          id: item.id,
          status: newStatus,
        }
      );

      if (response.status === "Failed") {
        console.log("Cannot update status");
        return;
      }

      setData((prevData) =>
        prevData.map((row) =>
          row.id === item.id ? { ...row, status: newStatus } : row
        )
      );
      console.log("Status updated");
      dispatch(showToast("Status Successfully Updated."));
      setTimeout(() => dispatch(hideToast()), 3000);
    } catch (error) {
      console.error("Error updating status:", error);
    }
  };

  const handleCancelCrop = () => {
    // Close the cropping modal without setting the image
    // setFolderImage({ value: null, src: "" }); // Reset the folder image
    setFolderImage((prev) => ({ ...prev, value: null, src: "" }));
    setShowCroppingModal(false); // Close the cropping modal
  };

  const handleCancel = () => {
    setFolder_name("");
    setTitle("");
    setDescription("");
    setFolderImage({ value: null, src: "" });
    // setCloseDate(null);
    setShowModal(false);
  };

  // const handleCloseDateChange = (date: Date | null) => {
  //   setCloseDate(date);
  // };

//   const filteredModalContacts = viewResponse.filter((contact) =>
//     contact.name.toLowerCase().trim().includes(searchQuery.toLowerCase().trim())
//   );
//   const indexOfLastContact = currentPage * contactsPerPage;
// const indexOfFirstContact = indexOfLastContact - contactsPerPage;
// const currentContacts = filteredModalContacts.slice(indexOfFirstContact, indexOfLastContact);

// const totalPages = Math.ceil(filteredModalContacts.length / contactsPerPage);

// console.log("CURRENT PAGE", currentPage)
// console.log("CURRENT PAGE ITEMS", currentContacts)
// console.log("FILTERED MODAL CONTENTS", filteredModalContacts)

  // Pagination button handlers
// const handleNextPage = () => {
//   if (currentPage < totalPages) {
//     setCurrentPage(currentPage + 1);
//   }
// };

// const handlePrevPage = () => {
//   if (currentPage >= 1) {
//     setCurrentPage(currentPage - 1);
//   }
// };

  const handleCheckboxChange = (selectedIds: Set<number>) => {
    console.log(selectedIds);
    setSelectedItems(selectedIds);
  };

  const handleViewResponse = async (item: Zigsaw) => {
    
  // Filter responses based on search query
 
    try {
      const response = await postDetails(APIList.GET_ZIGSAW_USER_DETAILS, {
        id: item.id,
      });
      // console.log(response.data.PhotoChallengepuzzleData);
      if (response.statusCode === 200 && response.data) {

        const responseInfo: ViewResponse[] =
          response.data.PhotoChallengepuzzleData.map((user: any) => ({
            id: user.id,
            name: user.name,
            profile: user.profile || profileIcon,
            solved_time: user.ZCPE_solved_time,
          }));
        setShowResponseModal(true);
        setViewResponse(responseInfo);
        // setFilteredData(responseInfo);
        console.log("VIEW RESPONSE INFO",responseInfo);
      }
    } catch (error) {
      console.error("Error fetching liked users:", error);
    }
  };
 
  const columns: TableColumn[] = [
    // { key: "id", label: "ID", sortable: true, dataType: "string" },
    {
      key: "folder_name",
      label: "Folder Name",
      sortable: true,
      dataType: "string",
    },
    { key: "title", label: "Title", sortable: true, dataType: "string" },
    { key: "description", label: "Contest Text", dataType: "string" ,
      //  render: (item)=> item.description ? item.description : "N/A"
    },
    { key: "folder_image", label: "Folder Image", dataType: "image" },
    {
      key: "",
      label: "Report",
      dataType: "button",
      button: {
        label: (item) => `View (${item.count || 0})`,
        onClick: handleViewResponse,
      },
    },
    // { key: "closeDate", label: "Close Date" },
  ];

  const buttons = [
    {
      label: "Delete",
      theme: "danger",
      icon: <Trash3Fill />,
      onClick: () => setShowDeleteModal(true),
      disabled: selectedItems.size === 0,
    },
    {
      label: "Add New",
      theme: "warning",
      icon: <PlusCircleFill />,
      onClick: handleShowModal,
    },
  ];  

  return (
    <div>
      <PageHeader buttons={buttons} />
      <CommonTable<Zigsaw>
        data={data}
        columns={columns}
        onView={(item) => console.log("View:", item)}
        onEdit={editItem}
        onDelete={deleteItemById}
        onStatusToggle={toggleStatus}
        pagination={true}
        rowsPerPage={10}
        actions={{
          view: false,
          edit: true,
          delete: true,
          checkbox: true,
          status: true,
          showModal: false,
        }}
        onCheckboxChange={handleCheckboxChange}
      />
      <Modal show={showModal} onHide={handleCloseModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            {isEditing ? "Edit" : "Add"} Zigsaw Challenge
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {errorMessage && (
            <div className="alert alert-danger" role="alert">
              {errorMessage}
            </div>
          )}
          <form onSubmit={submitDetails}>
            <div className="input-wrapper">
              <InputField
                name="folderName"
                label="Folder Name"
                type="text"
                value={folder_name}
                placeholder="Enter Folder Name"
                maxLength={50}
                required={true}
                onChangeInput={handleFolderChange}
              />
              <div className="character-counter">
                {folder_name.length}/{50}
              </div>
            </div>

            <div className="input-wrapper">
              <InputField
                name="title"
                label="Title"
                type="text"
                value={title}
                placeholder="Enter Title"
                maxLength={100}
                required={true}
                onChangeInput={handleTitleChange}
              />
              <div className="character-counter">
                {title.length}/{100}
              </div>
            </div>

            <div className="input-wrapper">
              <InputField
                name="description"
                label="Description"
                type="text"
                value={description}
                placeholder="Enter Description"
                maxLength={150}
                required={true}
                onChangeInput={handleDescriptionChange}
              />
              <div className="character-counter">
                {description.length}/{150}
              </div>
            </div>
            {/* <CustomDatePicker
              label="Close Date"
              name="closeDate"
              required={true}
              dateFormat={"MMMM d, yyyy"}
              onChange={handleCloseDateChange}
              defaultDate={closeDate}
            /> */}
            <div className="upload-information mb-4">
              <p className="font-14 mb-4 text-danger fw-bold">
                Uploads must be JPG / JPEG / PNG
                <span style={{ color: "red", fontWeight: "bold" }}>*</span>
              </p>
              <div className="mb-2">
                <div className="upload-image-wrapper d-flex flex-column">
                  {folderImage.src && (
                    <>
                      {/* <span
                        className="remove-image-btn font-14 cursor-pointer"
                        onClick={removeImage}
                      >
                        Remove
                      </span> */}
                      <img
                        src={folderImage.src}
                        alt="video-challenge-image"
                        width={150}
                      />
                    </>
                  )}
                </div>
              </div>
              <label htmlFor="photo">
                <div className="upload-btn-wrapper font-14 d-flex align-items-center justify-content-center gap-1">
                  <i className="fa-regular fa-image"></i>
                  <span>
                    {folderImage.src ? "Change Photo" : "Upload Folder Image"}
                  </span>
                </div>
              </label>
              <InputField
                type="file"
                name="photo"
                id="photo"
                value={""}
                className="d-none"
                onChangeInput={handleCoverImageChange}
              />
            </div>
            <div className="add-video-challenge-btn-bottom d-flex flex-column-reverse flex-md-row align-items-md-center justify-content-md-center gap-3 mb-5">
              <CustomButton theme="red" size="md" onClick={handleCancel}>
                Cancel
              </CustomButton>
              <CustomButton theme="yellow" size="md" type="submit">
                Submit
              </CustomButton>
            </div>
          </form>
        </Modal.Body>
      </Modal>

      <Modal
        show={showDeleteModal}
        onHide={handleCloseDeleteModal}
        centered
        className="deleteAll-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you want to delete?</p>
          <Button className="btn-danger" onClick={handleBulkDelete}>
            Delete
          </Button>
          <Button
            className="btn-warning text-white"
            onClick={handleCloseDeleteModal}
          >
            Cancel
          </Button>
        </Modal.Body>
      </Modal>

      {/* Cropping Modal */}
      {folderImage.value && (
        <CroppingModal
          show={showCroppingModal}
          handleClose={() => setShowCroppingModal(false)}
          image={folderImage.src}
          onCrop={handleCrop}
          onCancel={handleCancelCrop}
        />
      )}

      
<Modal
        show={showResponseModal}
        onHide={handleCloseResponseModal}
        centered
        dialogClassName="custom-modal-size"
        onClick={(e:any) => e.stopPropagation()}
      >
        <Modal.Header closeButton>
          <Modal.Title>View Response</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <div className="zigsaw-response-search">
          {/* <BsSearch className="search-icon" /> */}
          {/* <input
            type="text"
            placeholder="Search People"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          /> */}
          <InputField
            name="search"
            // label="Contact Email ID"
            type="text"
            value={query}
            // value={searchTerm}
            placeholder="Search"
            onChangeInput={(e) => setQuery(e.target.value)}
            // onChangeInput={(e) =>
            //   setSearchQuery(e.target.value)
            // }
            // onChangeInput={handleSearch}

          />
        </div>
        <div>
          {/* {searchQuery && filteredModalContacts.length === 0 ? (
            <p className="font-14">No data available.</p>
          ) : ( */}
           {
            paginatedData.map((user:any, index:any) => (
              <div key={index} className="d-flex align-items-center mb-3">
                <div className="me-3">
                  <img
                    src={user.profile ? user.profile : profileIcon}
                    style={{
                      width: "50px",
                      height: "50px",
                      borderRadius: "50%",
                      objectFit: "cover",
                    }}
                  />
                </div>
                <div>
                  <p className="mb-0 font-14">
                    <strong>{user.name}</strong>
                  </p>
                  <p className="mb-0 font-14">
                    Time Taken to Solve: {user.solved_time || "N/A"} Seconds
                  </p>
                </div>
              </div>
            ))
          }
          </div>
        </Modal.Body>
        <Modal.Footer style={{ justifyContent: "space-between" }}>
         
        {/* <button className="page-button" onClick={handlePrevPage} disabled={currentPage === 1}>
        <SlArrowLeft />
      </button> */}

        <button
         className="page-button"
          disabled={pageNumber === 1}
          onClick={() => setPageNumber(pageNumber - 1)}
        >
           <SlArrowLeft />
        </button>
      {/* <span>
       { totalPages !== 0 ? `Page ${currentPage} of ${totalPages}` : `Page 0 of 0`}
      </span> */}

       <span>
          { totalPages !== 0 ? `Page ${pageNumber} of ${totalPages}` : `Page 0 of 0`}
        </span>
      
      {/* <button  className="page-button" onClick={handleNextPage} disabled={currentPage === totalPages}>
        <SlArrowRight />
      </button> */}

       <button
       className="page-button"
          disabled={pageNumber === totalPages}
          onClick={() => setPageNumber(pageNumber + 1)}
        >
           <SlArrowRight />
        </button>

    {/* <div className="pagination">
          {Array.from({ length: totalPages }, (_, index) => (
            <Button
              key={index}
              variant={index + 1 === currentPage ? 'primary' : 'secondary'}
              onClick={() => handlePageChange(index + 1)}
              className="me-2"
            >
              {index + 1}
            </Button>
          ))}
        </div> */}
      <Button variant="danger" onClick={handleCloseResponseModal}>
        Close
      </Button>
        </Modal.Footer>
      </Modal>


    </div>
  );
};

export default VideoChallengeData;